import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/PriceMatrix';
import './PriceMatrix.css';
import StarRatingComponent from 'react-star-rating-component';
import { Button, FormGroup } from 'react-bootstrap';

class PriceMatrix extends Component {
    constructor(props) {
        super(props);

        this.state = {
            matrixValues: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.inputOnClick = this.inputOnClick.bind(this);
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
        if (!localStorage.getItem('customer')) {
            window.open('/customer-search', '_self');
        }

        this.props.history.push('/price-matrix/');

        this.props.queryPriceMatrix();
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.querySetPriceMatrix(this.props.priceMatrix);
    }

    inputOnClick(e) {
        var thisRadioBtn = e.target.value;

        var data = [];
        data[0] = thisRadioBtn;
        data[1] = this.props.priceMatrix;

        this.props.selectMatrixRating(data);
    }

    isSafari() {
        return navigator.vendor.match(/apple/i) &&
            !navigator.userAgent.match(/Opera|OPT\//)
    }

    render() {
        return (
            <div style={{width: "fit-content"}}>
                <h1>Matrix Price Ratings</h1>
                <p className={this.props.priceMatrix ? 'hidden' : ''}>Unable to retrieve Matrix Price Ratings for this customer.</p>
                <br />
                <div className={this.props.priceMatrix ? 'price-rate-offset' : 'hidden'} id={this.isSafari() === true ? "safari-matrix-stars" : "matrix-stars"}>
                    <div id={this.isSafari() === true ? "safari-matrix-star-labels" : "matrix-star-labels" }>
                        <b>
                            Below
                            Avg
                            Above
                        </b>
                    </div>

                    <StarRatingComponent
                        name="ratePM"
                        editing={false}
                        value={1}
                        starCount={3}
                    />
                    <StarRatingComponent
                        name="ratePM"
                        editing={false}
                        value={2}
                        starCount={3}
                    />
                    <StarRatingComponent
                        name="ratePM"
                        editing={false}
                        value={3}
                        starCount={3}
                    />
                </div>

                <div className="clear"></div>

                <form onSubmit={this.handleSubmit} >
                    <FormGroup
                        controlId="priceMatrixForm"
                    >
                        <div id="price-rate-layout">
                            {this.props.priceMatrix && this.props.priceMatrix.map(line =>
                                <div key={line.Group}>
                                    <p className="category-name">{line.CategoryName}</p>
                                    <div className="price-rate-offset">

                                        <fieldset>
                                            {line.Rate.map(rate =>
                                                <input type="radio"
                                                    key={rate.MatrixId}
                                                    name={line.Group}
                                                    value={rate.MatrixId}
                                                    defaultChecked={rate.CurrentlyAssigned === "1"}
                                                    onChange={this.inputOnClick}
                                                    className={rate.Rate === "1" ? "rate-one" : rate.Rate === "2" ? "rate-two" : "rate-three"}
                                                />
                                            )}
                                        </fieldset>

                                    </div>
                                    <div className="clear"></div>
                                </div>
                            )}
                        </div>
                        <br />
                        <Button type="submit" className={this.props.priceMatrix ? '' : 'hidden'}>Submit</Button>
                    </FormGroup>
                </form>
                <p className={this.props.priceMatrix ? '' : 'hidden'}>{this.props.saveMessage}</p>
            </div>
        );
    }
}

export default connect(
    state => state.priceMatrix,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(PriceMatrix);


// WEBPACK FOOTER //
// ./src/components/sales/PriceMatrix.js